import React, {useState, useEffect} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Toggle, Icon , Modal, Card} from '@ui-kitten/components';
import { StyleSheet , TouchableOpacity, View, Dimensions } from 'react-native';
import * as RootNavigation from '../../../root.navigation.js';
import { ThemeContext } from '../../../theme-context';
import trackerApi from '../../api/tracker';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { showMessage, hideMessage } from "react-native-flash-message";
import { SupervisorInfo } from './profile/supervisor-information';

const width = Dimensions.get('window').width;

const PersonIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='person'/>
);
const EditIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='edit-2'/>
);

const PeopleIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='people-outline'/>
);

const DoneIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='checkmark-square-2'/>
);
const BriefcaseIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='briefcase'/>
);
const TextIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='file-text'/>
);

const CardIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='credit-card'/>
);
const AlertIcon = (props) => (
  <Icon {...props} name='alert-triangle' style={{width:48, height:48, marginHorizontal:5}} fill='#FF3B38'/>
);
export const Settings = () => {
  const [subsets, setSubsets] = useState([])
  const [supervisor, setSupervisor] = useState([])
  const [visible2, setVisible2] = React.useState(false);
  const [deleteSub, setDeleteSub] = React.useState(false);

  const getSubsets = async() =>{
    const token =  await AsyncStorage.getItem('userId');

    const response = await trackerApi.post('/app/getSubsets', {}, {
      headers: {Authorization: `Bearer ${token}`}
    });
    if(response.data.status) setSubsets(response.data.subsets)
    else showMessage({
        message: `خطای دسترسی به دیتابیس`,
        type: "danger",
      });

      const response2 = await trackerApi.post('/app/getSupervisor', {}, {
        headers: {Authorization: `Bearer ${token}`}
      });
      if(response2.data.status) setSupervisor(response2.data.supervisor)
      else showMessage({
          message: `خطای دسترسی به دیتابیس`,
          type: "danger",
        });
  }

  useEffect (() => {
    getSubsets()
  }, [])

  const deleteUser = async() => {
    const token =  await AsyncStorage.getItem('userId');
    const response = await trackerApi.post('/app/deleteSubsets', {id: deleteSub.id}, {
      headers: {Authorization: `Bearer ${token}`}
    });
    if(response.data.status) {
      getSubsets()
    showMessage({
        message: `با موفقیت حذف شد`,
        type: "success",
      });
      setVisible2(false)
    }else{
    console.log(response.data);
    setVisible2(false)
    showMessage({
        message: `خطای دسترسی به دیتابیس`,
        type: "danger",
      });
    }
  }

  return (
    <Layout
    style={styles.item}
    >
  {
    subsets[0] ? subsets.map((item, index) => {
      return(
        <>
         <Layout key={index} style={styles.contentContainer}>
          <View style={{flexDirection:'row', alignItems:'center', flex: 1}}>
           <PersonIcon />
           <View>
             <Text style={styles.text}>{item.subsetName}</Text>
             <Text appearance='hint' category='c2' style={styles.text}>{item.subset}</Text>
           </View>
          </View>
          <View>
          <View style={{flexDirection:'row', alignItems:'center', justifyContent:'flex-end', flex: 1, marginHorizontal:5}}>
          <Button size='tiny' onPress={()=>{RootNavigation.navigate('SubsetProfile', {subset: item.subset})}} status='info' appearance='outline' style={{borderRadius:5, marginHorizontal:5}}>پروفایل</Button>
          <Button  size='tiny' onPress={()=>{RootNavigation.navigate('SubsetTask', {subset: item})}} status='info' style={{borderRadius:5, marginHorizontal:5}}>کارها</Button>
          </View>
          <Button size='tiny' onPress={()=>{setVisible2(true); setDeleteSub(item)}} status='danger' appearance='outline' style={{borderRadius:5, marginHorizontal:10, marginTop: 5}}>حذف کاربر</Button>
          </View>
         </Layout>
         <Divider style={{width: 0.9*width}}/>
         <Modal
            visible={visible2}
            style={{width:width-20}}
            backdropStyle={styles.backdrop}
            onBackdropPress={() => setVisible2(false)}>
            <Card disabled={false} style={{padding:10}}>
            <View disabled={false} style={{padding:10, justifyContent: 'center', alignItems:'center', flex:1}}>
            <AlertIcon />
            <Text style={{marginBottom:10}} category='h6' status='danger'>حذف کاربر</Text>
            <Text style={{marginBottom:10, lineHeight:25}}>در صورت اطمینان از حذف زیر مجموعه ادامه دهید.</Text>

            </View>

              <View style={{flexDirection:'row', justifyContent:'flex-end'}}>
              <Button appearance='ghost' style={{marginHorizontal:5, flex:1}} onPress = {()=>{setVisible2(false)}}>
                انصراف
              </Button>
              <Button style={{marginHorizontal:5, flex:2}} status='danger' onPress = {()=>{deleteUser()}}>
                 حذف
               </Button>
               </View>
            </Card>
          </Modal>
         </>
      )
    }) : <SupervisorInfo supervisor={supervisor ? supervisor : 'nobody'}/>

  }


    </Layout>
  );
};


const styles = StyleSheet.create({

  contentContainer: {
  flexDirection:'row' ,
  alignItems:'center',
  paddingVertical:12,
  },
  item: {
    marginTop: 10,
    paddingHorizontal:6,
    alignItems: 'center'

  },
  text:{
    marginHorizontal:10
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
});
